module.exports = __webpack_public_path__ + "static/media/deal-discount-voucher.fc737e12.png";